import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SystemInfo from '../../util/SystemInfo';

const MaintenancePage = () => {
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            fontFamily: "'Outfit', sans-serif"
        }}>
            <Container>
                <Row className="justify-content-center text-center">
                    <Col md={8} lg={6}>
                        <div className="maintenance-card p-5 shadow-lg rounded-4 bg-white" style={{
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            backdropFilter: 'blur(10px)',
                            animation: 'fadeIn 1s ease-out'
                        }}>
                            <img 
                                src={SystemInfo.logo} 
                                alt={SystemInfo.name} 
                                style={{ maxWidth: '180px', marginBottom: '2rem' }}
                            />
                            <h1 className="fw-bold mb-3" style={{ color: '#2d3436' }}>Estamos en Mantenimiento</h1>
                            <p className="text-muted mb-3 fs-5">
                                Estamos realizando mejoras en {SystemInfo.name} para brindarte una mejor experiencia. 
                            </p>
                            <div className="alert alert-info py-2 rounded-3 mb-4" style={{ backgroundColor: '#e3f2fd', border: 'none', color: '#0d47a1' }}>
                                <i className="bi bi-clock-history me-2"></i>
                                <strong>Horario:</strong> De 15:00 a 20:00 hrs.
                            </div>
                            <p className="text-muted mb-4">
                                Volveremos muy pronto. Agradecemos tu paciencia.
                            </p>
                            <div className="d-flex justify-content-center mb-4">
                                <div className="spinner-grow text-primary mx-1" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-primary mx-1" role="status" style={{ animationDelay: '0.2s' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-primary mx-1" role="status" style={{ animationDelay: '0.4s' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <hr className="my-4" />
                            <small className="text-secondary fw-medium">
                                Para cualquier duda contactese con el equipo de remuneraciones.
                            </small>
                        </div>
                    </Col>
                </Row>
            </Container>
            <style>
                {`
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .maintenance-card {
                        transition: transform 0.3s ease;
                    }
                    .maintenance-card:hover {
                        transform: translateY(-5px);
                    }
                `}
            </style>
        </div>
    );
};

export default MaintenancePage;
